import { __awaiter } from "tslib";
const run = (buf) => __awaiter(void 0, void 0, void 0, function* () {
    yield buf.log([
        { text: '' },
        { text: 'Commands:' },
        {
            text: [
                {
                    text: '  create',
                    bold: true,
                },
                {
                    text: '                 Create a new system.',
                },
            ],
        },
        {
            text: [
                {
                    text: '  delete',
                    bold: true,
                },
                {
                    text: '                 Delete systems.',
                },
            ],
        },
        {
            text: [
                {
                    text: '  list',
                    bold: true,
                },
                {
                    text: '                   Show system details.',
                },
            ],
        },
        {
            text: [
                {
                    text: '  prove',
                    bold: true,
                },
                {
                    text: '                  Generate a proof.',
                },
            ],
        },
        {
            text: [
                {
                    text: '  rename',
                    bold: true,
                },
                {
                    text: "                 Change a system's alias.",
                },
            ],
        },
        {
            text: [
                {
                    text: '  verify',
                    bold: true,
                },
                {
                    text: '                 Verify a proof.',
                },
            ],
        },
        { text: '' },
        {
            text: [
                { text: 'Run `' },
                { text: 'COMMAND -h', bold: true },
                { text: '` for more information on specific commands.' },
            ],
        },
        { text: 'Press ^C to abort current expression, ^K to clear terminal buffer.' },
        { text: '' },
    ]);
});
export const help = {
    run,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVscC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy93ZWItdGVybWluYWwvY29tbWFuZC9oZWxwLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFFQSxNQUFNLEdBQUcsR0FBRyxDQUFPLEdBQW1CLEVBQUUsRUFBRTtJQUN4QyxNQUFNLEdBQUcsQ0FBQyxHQUFHLENBQUM7UUFDWixFQUFFLElBQUksRUFBRSxFQUFFLEVBQUU7UUFDWixFQUFFLElBQUksRUFBRSxXQUFXLEVBQUU7UUFDckI7WUFDRSxJQUFJLEVBQUU7Z0JBQ0o7b0JBQ0UsSUFBSSxFQUFFLFVBQVU7b0JBQ2hCLElBQUksRUFBRSxJQUFJO2lCQUNYO2dCQUNEO29CQUNFLElBQUksRUFBRSx1Q0FBdUM7aUJBQzlDO2FBQ0Y7U0FDRjtRQUNEO1lBQ0UsSUFBSSxFQUFFO2dCQUNKO29CQUNFLElBQUksRUFBRSxVQUFVO29CQUNoQixJQUFJLEVBQUUsSUFBSTtpQkFDWDtnQkFDRDtvQkFDRSxJQUFJLEVBQUUsa0NBQWtDO2lCQUN6QzthQUNGO1NBQ0Y7UUFDRDtZQUNFLElBQUksRUFBRTtnQkFDSjtvQkFDRSxJQUFJLEVBQUUsUUFBUTtvQkFDZCxJQUFJLEVBQUUsSUFBSTtpQkFDWDtnQkFDRDtvQkFDRSxJQUFJLEVBQUUseUNBQXlDO2lCQUNoRDthQUNGO1NBQ0Y7UUFDRDtZQUNFLElBQUksRUFBRTtnQkFDSjtvQkFDRSxJQUFJLEVBQUUsU0FBUztvQkFDZixJQUFJLEVBQUUsSUFBSTtpQkFDWDtnQkFDRDtvQkFDRSxJQUFJLEVBQUUscUNBQXFDO2lCQUM1QzthQUNGO1NBQ0Y7UUFDRDtZQUNFLElBQUksRUFBRTtnQkFDSjtvQkFDRSxJQUFJLEVBQUUsVUFBVTtvQkFDaEIsSUFBSSxFQUFFLElBQUk7aUJBQ1g7Z0JBQ0Q7b0JBQ0UsSUFBSSxFQUFFLDJDQUEyQztpQkFDbEQ7YUFDRjtTQUNGO1FBQ0Q7WUFDRSxJQUFJLEVBQUU7Z0JBQ0o7b0JBQ0UsSUFBSSxFQUFFLFVBQVU7b0JBQ2hCLElBQUksRUFBRSxJQUFJO2lCQUNYO2dCQUNEO29CQUNFLElBQUksRUFBRSxrQ0FBa0M7aUJBQ3pDO2FBQ0Y7U0FDRjtRQUNELEVBQUUsSUFBSSxFQUFFLEVBQUUsRUFBRTtRQUNaO1lBQ0UsSUFBSSxFQUFFO2dCQUNKLEVBQUUsSUFBSSxFQUFFLE9BQU8sRUFBRTtnQkFDakIsRUFBRSxJQUFJLEVBQUUsWUFBWSxFQUFFLElBQUksRUFBRSxJQUFJLEVBQUU7Z0JBQ2xDLEVBQUUsSUFBSSxFQUFFLDhDQUE4QyxFQUFFO2FBQ3pEO1NBQ0Y7UUFDRCxFQUFFLElBQUksRUFBRSxvRUFBb0UsRUFBRTtRQUM5RSxFQUFFLElBQUksRUFBRSxFQUFFLEVBQUU7S0FDYixDQUFDLENBQUM7QUFDTCxDQUFDLENBQUEsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLElBQUksR0FBRztJQUNsQixHQUFHO0NBQ0osQ0FBQyJ9